import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../../utils/axiosConfig";
import { IEmail } from "../../../../interfaces/IEmailAlerts";

const useEmails = () => {
    const [emails, setEmails] = useState<IEmail[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        getEmails();
    }, [])

    const getEmails = async () => {
        setIsLoading(true);

        try {
            const url = `emails`;
            const response = await axiosInstance.get(url);

            if (!response.data) {
                toast.error("An error occurred when getting the emails")
                setIsError(true);
            } else {
                setEmails(response.data);
                setIsError(false);
            }

        } catch (error) {
            toast.error("An error occurred when getting the emails")
            console.error("Error fetching emails:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const deleteEmail = async (email: IEmail) => {
        try {
            // Extract file IDs 
            const filesIdList = email.Files.map(file => Object.keys(file)[0]);
           
            const url = `emails`; 
    
            await axiosInstance.delete(url, { data: { fileIds: filesIdList } }); 
            
            getEmails();
        } catch (error) {
            toast.error("Failed to delete email");
            console.error("Error deleting email:", error);
        }
    };
    
    return { emails, isLoading, isError, deleteEmail }
}

export default useEmails;